export const TitledContent = ({ title = "", actions = [], children }) => {
    return <>
        <div className="d-sm-flex justify-content-between align-items-center mb-4 d-print-none">
            <h3 className="text-dark mb-0">{title}</h3>
            <div> {actions.map(action => action)} </div>
        </div>
        {children}
    </>
}